/* SETTINGS */
export const CHANGE_LEFT_SIDEBAR = "CHANGE_LEFT_SIDEBAR"
export const CHANGE_DASHBOARD_LAYOUT = "CHANGE_DASHBOARD_LAYOUT"
export const CHANGE_DRAGANDDROP_LAYOUT = "CHANGE_DRAGANDDROP_LAYOUT"

/*TOASTER*/
export const SET_TOASTER = "SET_TOASTER"

/* BATCH_LIST_SELECT */
export const SET_BATCH_LIST_ITEM = "SET_BATCH_LIST_ITEM"
export const TOGGLE_BATCH_LIST = "TOGGLE_BATCH_LIST"
export const TOGGLE_BATCH_LIST_ACTIVE = "TOGGLE_BATCH_LIST_ACTIVE"

/* BATCH_SIMPLE_LIST_SELECT */
export const SET_BATCH_SIMPLE_LIST_ITEM = "SET_BATCH_SIMPLE_LIST_ITEM"
export const TOGGLE_BATCH_SIMPLE_LIST = "TOGGLE_BATCH_SIMPLE_LIST"

/* CALL_DATA */
export const SET_CALL_DATA = "SET_CALL_DATA"
export const TOGGLE_CALL_AVAILABILITY = "TOGGLE_CALL_AVAILABILITY"

/* FILTERS */
export const SET_FILTER_DATA = "SET_FILTER_DATA"
export const TOGGLE_FILTER = "TOGGLE_FILTER"

/* AUTH */
export const REQUEST_CURRENT_USER = "REQUEST_CURRENT_USER"
export const RECEIVE_CURRENT_USER = "RECEIVE_CURRENT_USER"
export const ERROR_CURRENT_USER = "ERROR_CURRENT_USER"

/* INFO */
export const REQUEST_INFO = "REQUEST_INFO"
export const RECEIVE_INFO = "RECEIVE_INFO"
export const ERROR_INFO = "ERROR_INFO"

/* INFO-LOGIN */
export const REQUEST_INFO_LOGIN = "REQUEST_INFO_LOGIN"
export const RECEIVE_INFO_LOGIN = "RECEIVE_INFO_LOGIN"
export const UPDATE_INFO_LOGIN = "UPDATE_INFO_LOGIN"
export const ERROR_INFO_LOGIN = "ERROR_INFO_LOGIN"

/* AVAILABLE THEMES */
export const REQUEST_AVAILABLE_THEMES = "REQUEST_AVAILABLE_THEMES"
export const RECEIVE_AVAILABLE_THEMES = "RECEIVE_AVAILABLE_THEMES"
export const ERROR_AVAILABLE_THEMES = "ERROR_AVAILABLE_THEMES"

/* STRINGS */
export const REQUEST_STRINGS = "REQUEST_STRINGS"
export const RECEIVE_STRINGS = "RECEIVE_STRINGS"
export const UPDATE_STRINGS = "UPDATE_STRINGS"
export const ERROR_STRINGS = "ERROR_STRINGS"
export const TOGGLE_DEV_STRINGS = "TOGGLE_DEV_STRINGS"

/*ADMIN STRINGS*/
export const REQUEST_ADMIN_STRINGS = "REQUEST_ADMIN_STRINGS"
export const RECEIVE_ADMIN_STRINGS = "RECEIVE_ADMIN_STRINGS"
export const UPDATE_ADMIN_STRINGS = "UPDATE_ADMIN_STRINGS"
export const ERROR_ADMIN_STRINGS = "ERROR_ADMIN_STRINGS"

/* DATA_STRUCTURES */
export const REQUEST_DATA_STRUCTURE = "REQUEST_DATA_STRUCTURE"
export const RECEIVE_DATA_STRUCTURE = "RECEIVE_DATA_STRUCTURE"
export const ERROR_DATA_STRUCTURE = "ERROR_DATA_STRUCTURE"

/* ENUMS */
export const REQUEST_ENUMS = "REQUEST_ENUMS"
export const RECEIVE_ENUMS = "RECEIVE_ENUMS"
export const RELOAD_ENUMS = "RELOAD_ENUMS"
export const ERROR_ENUMS = "ERROR_ENUMS"

/* CLIENTS */
export const REQUEST_CLIENTS = "REQUEST_CLIENTS"
export const RECEIVE_CLIENTS = "RECEIVE_CLIENTS"
export const UPDATE_CLIENTS = "UPDATE_CLIENTS"
export const ERROR_CLIENTS = "ERROR_CLIENTS"

/* CLIENT_GROUPS */
export const REQUEST_CLIENT_GROUPS = "REQUEST_CLIENT_GROUPS"
export const RECEIVE_CLIENT_GROUPS = "RECEIVE_CLIENT_GROUPS"
export const UPDATE_CLIENT_GROUPS = "UPDATE_CLIENT_GROUPS"
export const ERROR_CLIENT_GROUPS = "ERROR_CLIENT_GROUPS"

/* COMPANIES */
export const REQUEST_COMPANIES = "REQUEST_COMPANIES"
export const RECEIVE_COMPANIES = "RECEIVE_COMPANIES"
export const UPDATE_COMPANIES = "UPDATE_COMPANIES"
export const ERROR_COMPANIES = "ERROR_COMPANIES"

/* LIQUIDATIONS */
export const REQUEST_LIQUIDATIONS = "REQUEST_LIQUIDATIONS"
export const RECEIVE_LIQUIDATIONS = "RECEIVE_LIQUIDATIONS"
export const UPDATE_LIQUIDATIONS = "UPDATE_LIQUIDATIONS"
export const ERROR_LIQUIDATIONS = "ERROR_LIQUIDATIONS"

/* LIQUIDATION TEMPLATES */
export const REQUEST_LIQUIDATION_TEMPLATES = "REQUEST_LIQUIDATION_TEMPLATES"
export const RECEIVE_LIQUIDATION_TEMPLATES = "RECEIVE_LIQUIDATION_TEMPLATES"
export const UPDATE_LIQUIDATION_TEMPLATES = "UPDATE_LIQUIDATION_TEMPLATES"
export const ERROR_LIQUIDATION_TEMPLATES = "ERROR_LIQUIDATION_TEMPLATES"

/* LIQUIDATORS */
export const REQUEST_LIQUIDATORS = "REQUEST_LIQUIDATORS"
export const RECEIVE_LIQUIDATORS = "RECEIVE_LIQUIDATORS"
export const RELOAD_LIQUIDATORS = "RELOAD_LIQUIDATORS"
export const UPDATE_LIQUIDATORS = "UPDATE_LIQUIDATORS"
export const ERROR_LIQUIDATORS = "ERROR_LIQUIDATORS"

/* ASSISTANTS */
export const REQUEST_ASSISTANTS = "REQUEST_ASSISTANTS"
export const RECEIVE_ASSISTANTS = "RECEIVE_ASSISTANTS"
export const RELOAD_ASSISTANTS = "RELOAD_ASSISTANTS"
export const UPDATE_ASSISTANTS = "UPDATE_ASSISTANTS"
export const ERROR_ASSISTANTS = "ERROR_ASSISTANTS"

/* BACKOFFICES */
export const REQUEST_BACKOFFICES = "REQUEST_BACKOFFICES"
export const RECEIVE_BACKOFFICES = "RECEIVE_BACKOFFICES"
export const RELOAD_BACKOFFICES = "RELOAD_BACKOFFICES"
export const UPDATE_BACKOFFICES = "UPDATE_BACKOFFICES"
export const ERROR_BACKOFFICES = "ERROR_BACKOFFICES"

/* CLIENTS-ANALYSES */
export const REQUEST_ANALYSES = "REQUEST_ANALYSES"
export const RECEIVE_ANALYSES = "RECEIVE_ANALYSES"
export const UPDATE_ANALYSES = "UPDATE_ANALYSES"
export const ERROR_ANALYSES = "ERROR_ANALYSES"

/* CLIENTS-FORMS */
export const REQUEST_FORMS = "REQUEST_FORMS"
export const RECEIVE_FORMS = "RECEIVE_FORMS"
export const UPDATE_FORMS = "UPDATE_FORMS"
export const ERROR_FORMS = "ERROR_FORMS"

/* CLIENTS-FORMS-DOWNLOAD */
export const REQUEST_FORMS_DOWNLOAD = "REQUEST_FORMS_DOWNLOAD"
export const RECEIVE_FORMS_DOWNLOAD = "RECEIVE_FORMS_DOWNLOAD"
export const ERROR_FORMS_DOWNLOAD = "ERROR_FORMS_DOWNLOAD"

/* INTERVENTIONS */
export const REQUEST_CLIENT_INTERVENTIONS = "REQUEST_CLIENT_INTERVENTIONS"
export const RECEIVE_CLIENT_INTERVENTIONS = "RECEIVE_CLIENT_INTERVENTIONS"
export const UPDATE_CLIENT_INTERVENTIONS = "UPDATE_CLIENT_INTERVENTIONS"
export const ERROR_CLIENT_INTERVENTIONS = "ERROR_CLIENT_INTERVENTIONS"

/* USERS */
export const REQUEST_USERS = "REQUEST_USERS"
export const RECEIVE_USERS = "RECEIVE_USERS"
export const UPDATE_USERS = "UPDATE_USERS"
export const ERROR_USERS = "ERROR_USERS"

/* BROKERAGES */
export const REQUEST_BROKERAGES = "REQUEST_BROKERAGES"
export const RECEIVE_BROKERAGES = "RECEIVE_BROKERAGES"
export const ERROR_BROKERAGES = "ERROR_BROKERAGES"

/* BILLING_HISTORY */
export const REQUEST_BILLING_OVERVIEW = "REQUEST_BILLING_OVERVIEW"
export const RECEIVE_BILLING_OVERVIEW = "RECEIVE_BILLING_OVERVIEW"
export const ERROR_BILLING_OVERVIEW = "ERROR_BILLING_OVERVIEW"

/* BILLING_REPORTS */
export const REQUEST_BILLING_REPORTS = "REQUEST_BILLING_REPORTS"
export const RECEIVE_BILLING_REPORTS = "RECEIVE_BILLING_REPORTS"
export const UPDATE_BILLING_REPORTS = "UPDATE_BILLING_REPORTS"
export const ERROR_BILLING_REPORTS = "ERROR_BILLING_REPORTS"

/* BILLING_REPORTS_FORMATS */
export const REQUEST_BILLING_REPORT_FORMATS = "REQUEST_BILLING_REPORT_FORMATS"
export const RECEIVE_BILLING_REPORT_FORMATS = "RECEIVE_BILLING_REPORT_FORMATS"
export const UPDATE_BILLING_REPORT_FORMATS = "UPDATE_BILLING_REPORT_FORMATS"
export const ERROR_BILLING_REPORT_FORMATS = "ERROR_BILLING_REPORT_FORMATS"

/* BILLING_RULES */
export const REQUEST_BILLING_RULES = "REQUEST_BILLING_RULES"
export const RECEIVE_BILLING_RULES = "RECEIVE_BILLING_RULES"
export const UPDATE_BILLING_RULES = "UPDATE_BILLING_RULES"
export const ERROR_BILLING_RULES = "ERROR_BILLING_RULES"

/* BILLING_CLOSURES */
export const REQUEST_BILLING_CLOSURES = "REQUEST_BILLING_CLOSURES"
export const RECEIVE_BILLING_CLOSURES = "RECEIVE_BILLING_CLOSURES"
export const UPDATE_BILLING_CLOSURES = "UPDATE_BILLING_CLOSURES"
export const ERROR_BILLING_CLOSURES = "ERROR_BILLING_CLOSURES"

/* BILLING_TABLES */
export const REQUEST_BILLING_TABLES = "REQUEST_BILLING_TABLES"
export const RECEIVE_BILLING_TABLES = "RECEIVE_BILLING_TABLES"
export const UPDATE_BILLING_TABLES = "UPDATE_BILLING_TABLES"
export const ERROR_BILLING_TABLES = "ERROR_BILLING_TABLES"

/* BILLING_TEMPLATES */
export const REQUEST_BILLING_TEMPLATES = "REQUEST_BILLING_TEMPLATES"
export const RECEIVE_BILLING_TEMPLATES = "RECEIVE_BILLING_TEMPLATES"
export const UPDATE_BILLING_TEMPLATES = "UPDATE_BILLING_TEMPLATES"
export const ERROR_BILLING_TEMPLATES = "ERROR_BILLING_TEMPLATES"

/* BILLING_FUNDS */
export const REQUEST_BILLING_FUNDS = "REQUEST_BILLING_FUNDS"
export const RECEIVE_BILLING_FUNDS = "RECEIVE_BILLING_FUNDS"
export const UPDATE_BILLING_FUNDS = "UPDATE_BILLING_FUNDS"
export const ERROR_BILLING_FUNDS = "ERROR_BILLING_FUNDS"

/* BILLING_UNASSIGNED */
export const REQUEST_BILLING_UNASSIGNED_ENTRIES = "REQUEST_BILLING_UNASSIGNED_ENTRIES"
export const RECEIVE_BILLING_UNASSIGNED_ENTRIES = "RECEIVE_BILLING_UNASSIGNED_ENTRIES"
export const UPDATE_BILLING_UNASSIGNED_ENTRIES = "UPDATE_BILLING_UNASSIGNED_ENTRIES"
export const ERROR_BILLING_UNASSIGNED_ENTRIES = "ERROR_BILLING_UNASSIGNED_ENTRIES"

/* BILLING_MONTHLY_BALANCE */
export const REQUEST_BILLING_MONTHLY_BALANCE = "REQUEST_BILLING_MONTHLY_BALANCE"
export const RECEIVE_BILLING_MONTHLY_BALANCE = "RECEIVE_BILLING_MONTHLY_BALANCE"
export const ERROR_BILLING_MONTHLY_BALANCE = "ERROR_BILLING_MONTHLY_BALANCE"

/* ADVISORS */
export const REQUEST_ADVISORS = "REQUEST_ADVISORS"
export const RECEIVE_ADVISORS = "RECEIVE_ADVISORS"
export const RELOAD_ADVISORS = "RELOAD_ADVISORS"
export const UPDATE_ADVISORS = "UPDATE_ADVISORS"
export const ERROR_ADVISORS = "ERROR_ADVISORS"

/* CERTIFICATIONS */
export const REQUEST_CERTIFICATIONS = "REQUEST_CERTIFICATIONS"
export const RECEIVE_CERTIFICATIONS = "RECEIVE_CERTIFICATIONS"
export const UPDATE_CERTIFICATIONS = "UPDATE_CERTIFICATIONS"
export const ERROR_CERTIFICATIONS = "ERROR_CERTIFICATIONS"

/* CONTRACTUAL_DATA */
export const REQUEST_CONTRACTUAL_DATA = "REQUEST_CONTRACTUAL_DATA"
export const RECEIVE_CONTRACTUAL_DATA = "RECEIVE_CONTRACTUAL_DATA"
export const UPDATE_CONTRACTUAL_DATA = "UPDATE_CONTRACTUAL_DATA"
export const ERROR_CONTRACTUAL_DATA = "ERROR_CONTRACTUAL_DATA"

/* CONSULTANT_POSITIONS */
export const REQUEST_CONSULTANT_POSITIONS = "REQUEST_CONSULTANT_POSITIONS"
export const RECEIVE_CONSULTANT_POSITIONS = "RECEIVE_CONSULTANT_POSITIONS"
export const UPDATE_CONSULTANT_POSITIONS = "UPDATE_CONSULTANT_POSITIONS"
export const ERROR_CONSULTANT_POSITIONS = "ERROR_CONSULTANT_POSITIONS"

/* MANAGER_POSITIONS */
export const REQUEST_MANAGER_POSITIONS = "REQUEST_MANAGER_POSITIONS"
export const RECEIVE_MANAGER_POSITIONS = "RECEIVE_MANAGER_POSITIONS"
export const UPDATE_MANAGER_POSITIONS = "UPDATE_MANAGER_POSITIONS"
export const ERROR_MANAGER_POSITIONS = "ERROR_MANAGER_POSITIONS"

/* LEADS */
export const REQUEST_LEADS = "REQUEST_LEADS"
export const RECEIVE_LEADS = "RECEIVE_LEADS"
export const UPDATE_LEADS = "UPDATE_LEADS"
export const ERROR_LEADS = "ERROR_LEADS"

/* LEAD_STORAGES */
export const REQUEST_LEAD_STORAGES = "REQUEST_LEAD_STORAGES"
export const RECEIVE_LEAD_STORAGES = "RECEIVE_LEAD_STORAGES"
export const UPDATE_LEAD_STORAGES = "UPDATE_LEAD_STORAGES"
export const ERROR_LEAD_STORAGES = "ERROR_LEAD_STORAGES"

/* ROLES */
export const REQUEST_ROLES = "REQUEST_ROLES"
export const RECEIVE_ROLES = "RECEIVE_ROLES"
export const UPDATE_ROLES = "UPDATE_ROLES"
export const ERROR_ROLES = "ERROR_ROLES"

/* ACTIVITIES */
export const REQUEST_ACTIVITIES = "REQUEST_ACTIVITIES"
export const RECEIVE_ACTIVITIES = "RECEIVE_ACTIVITIES"
export const UPDATE_ACTIVITIES = "UPDATE_ACTIVITIES"
export const ERROR_ACTIVITIES = "ERROR_ACTIVITIES"


/* ACTIVITIES_SETTINGS */
export const REQUEST_ACTIVITIES_SETTINGS = "REQUEST_ACTIVITIES_SETTINGS"
export const RECEIVE_ACTIVITIES_SETTINGS = "RECEIVE_ACTIVITIES_SETTINGS"
export const UPDATE_ACTIVITIES_SETTINGS = "UPDATE_ACTIVITIES_SETTINGS"
export const ERROR_ACTIVITIES_SETTINGS = "ERROR_ACTIVITIES_SETTINGS"

/* MY CONTRACTS */
export const REQUEST_CONTRACTS = "REQUEST_CONTRACTS"
export const RECEIVE_CONTRACTS = "RECEIVE_CONTRACTS"
export const UPDATE_CONTRACTS = "UPDATE_CONTRACTS"
export const RELOAD_CONTRACTS = "RELOAD_CONTRACTS"
export const ERROR_CONTRACTS = "ERROR_CONTRACTS"

/* DISPATCHES */
export const REQUEST_CONTRACT_DISPATCHES = "REQUEST_CONTRACT_DISPATCHES"
export const RECEIVE_CONTRACT_DISPATCHES = "RECEIVE_CONTRACT_DISPATCHES"
export const UPDATE_CONTRACT_DISPATCHES = "UPDATE_CONTRACT_DISPATCHES"
export const RELOAD_CONTRACT_DISPATCHES = "RELOAD_CONTRACT_DISPATCHES"
export const ERROR_CONTRACT_DISPATCHES = "ERROR_CONTRACT_DISPATCHES"

/* RISKS */
export const REQUEST_CONTRACT_RISKS = "REQUEST_CONTRACT_RISKS"
export const RECEIVE_CONTRACT_RISKS = "RECEIVE_CONTRACT_RISKS"
export const UPDATE_CONTRACT_RISKS = "UPDATE_CONTRACT_RISKS"
export const ERROR_CONTRACT_RISKS = "ERROR_CONTRACT_RISKS"

/* INTERVENTIONS */
export const REQUEST_CONTRACT_INTERVENTIONS = "REQUEST_CONTRACT_INTERVENTIONS"
export const RECEIVE_CONTRACT_INTERVENTIONS = "RECEIVE_CONTRACT_INTERVENTIONS"
export const UPDATE_CONTRACT_INTERVENTIONS = "UPDATE_CONTRACT_INTERVENTIONS"
export const ERROR_CONTRACT_INTERVENTIONS = "ERROR_CONTRACT_INTERVENTIONS"

/* NOTIFICATIONS */
export const REQUEST_NOTIFICATIONS = "REQUEST_NOTIFICATIONS"
export const RECEIVE_NOTIFICATIONS = "RECEIVE_NOTIFICATIONS"
export const UPDATE_NOTIFICATIONS = "UPDATE_NOTIFICATIONS"
export const ERROR_NOTIFICATIONS = "ERROR_NOTIFICATIONS"

/* SETTINGS_DASHBOARD */
export const REQUEST_SETTINGSMESSAGES = "REQUEST_SETTINGSMESSAGES"
export const RECEIVE_SETTINGSMESSAGES = "RECEIVE_SETTINGSMESSAGES"
export const ERROR_SETTINGSMESSAGES = "ERROR_SETTINGSMESSAGES"

/* SETTINGS_ENUMS */
export const REQUEST_SETTINGS_ENUMS = "REQUEST_SETTINGS_ENUMS"
export const RECEIVE_SETTINGS_ENUMS = "RECEIVE_SETTINGS_ENUMS"
export const UPDATE_SETTINGS_ENUMS = "UPDATE_SETTINGS_ENUMS"
export const ERROR_SETTINGS_ENUMS = "ERROR_SETTINGS_ENUMS"

/* SETTINGS_EMAILTEMPLATES */
export const REQUEST_SETTINGS_EMAILTEMPLATES = "REQUEST_SETTINGS_EMAILTEMPLATES"
export const RECEIVE_SETTINGS_EMAILTEMPLATES = "RECEIVE_SETTINGS_EMAILTEMPLATES"
export const UPDATE_SETTINGS_EMAILTEMPLATES = "UPDATE_SETTINGS_EMAILTEMPLATES"
export const ERROR_SETTINGS_EMAILTEMPLATES = "ERROR_SETTINGS_EMAILTEMPLATES"

/* SETTINGS_PDFTEMPLATES */
export const REQUEST_SETTINGS_PDFTEMPLATES = "REQUEST_SETTINGS_PDFTEMPLATES"
export const RECEIVE_SETTINGS_PDFTEMPLATES = "RECEIVE_SETTINGS_PDFTEMPLATES"
export const UPDATE_SETTINGS_PDFTEMPLATES = "UPDATE_SETTINGS_PDFTEMPLATES"
export const ERROR_SETTINGS_PDFTEMPLATES = "ERROR_SETTINGS_PDFTEMPLATES"

/* CONTRACT STATISTICS */
export const REQUEST_CONTRACT_STATS = "REQUEST_CONTRACT_STATS"
export const RECEIVE_CONTRACT_STATS = "RECEIVE_CONTRACT_STATS"
export const ERROR_CONTRACT_STATS = "ERROR_CONTRACT_STATS"

/* CONTRACT REMINDERS */
export const REQUEST_CONTRACT_REMINDERS = "REQUEST_CONTRACT_REMINDERS"
export const RECEIVE_CONTRACT_REMINDERS = "RECEIVE_CONTRACT_REMINDERS"
export const ERROR_CONTRACT_REMINDERS = "ERROR_CONTRACT_REMINDERS"

/* ITEM */
export const REQUEST_ITEM = "REQUEST_ITEM"
export const RECEIVE_ITEM = "RECEIVE_ITEM"
export const UPDATE_ITEM = "UPDATE_ITEM"
export const RELOAD_ITEM = "RELOAD_ITEM"
export const ERROR_ITEM = "ERROR_ITEM"

/* LAZY_OPTIONS */
export const REQUEST_LAZY_LOAD = "REQUEST_LAZY_LOAD"
export const RECEIVE_LAZY_LOAD = "RECEIVE_LAZY_LOAD"
export const ERROR_LAZY_LOAD = "ERROR_LAZY_LOAD"

/* CLIENT ZONE */
/* AUTH */
export const REQUEST_CLZ_CURRENT_USER = "REQUEST_CLZ_CURRENT_USER"
export const RECEIVE_CLZ_CURRENT_USER = "RECEIVE_CLZ_CURRENT_USER"
export const ERROR_CLZ_CURRENT_USER = "ERROR_CLZ_CURRENT_USER"

/* LIQUIDATIONS */
export const REQUEST_CLZ_LIQUIDATIONS = "REQUEST_CLZ_LIQUIDATIONS"
export const RECEIVE_CLZ_LIQUIDATIONS = "RECEIVE_CLZ_LIQUIDATIONS"
export const UPDATE_CLZ_LIQUIDATIONS = "UPDATE_CLZ_LIQUIDATIONS"
export const ERROR_CLZ_LIQUIDATIONS = "ERROR_CLZ_LIQUIDATIONS"

/* LIQUIDATIONS DASHBOARD */
export const REQUEST_LIQUIDATIONS_DASHBOARD = "REQUEST_LIQUIDATIONS_DASHBOARD"
export const RECEIVE_LIQUIDATIONS_DASHBOARD = "RECEIVE_LIQUIDATIONS_DASHBOARD"
export const UPDATE_LIQUIDATIONS_DASHBOARD = "UPDATE_LIQUIDATIONS_DASHBOARD"
export const ERROR_LIQUIDATIONS_DASHBOARD = "ERROR_LIQUIDATIONS_DASHBOARD"

/* MY CONTRACTS */
export const REQUEST_CLZ_CONTRACTS = "REQUEST_CLZ_CONTRACTS"
export const RECEIVE_CLZ_CONTRACTS = "RECEIVE_CLZ_CONTRACTS"
export const UPDATE_CLZ_CONTRACTS = "UPDATE_CLZ_CONTRACTS"
export const ERROR_CLZ_CONTRACTS = "ERROR_CLZ_CONTRACTS"

/* SETTINGS_PRODUCTS */
export const REQUEST_SETTINGS_PRODUCTS = "REQUEST_SETTINGS_PRODUCTS"
export const RECEIVE_SETTINGS_PRODUCTS = "RECEIVE_SETTINGS_PRODUCTS"
export const UPDATE_SETTINGS_PRODUCTS = "UPDATE_SETTINGS_PRODUCTS"
export const ERROR_SETTINGS_PRODUCTS = "ERROR_SETTINGS_PRODUCTS"

/* BUSINESSCASES */
export const REQUEST_BUSINESSCASES = "REQUEST_BUSINESSCASES"
export const RECEIVE_BUSINESSCASES = "RECEIVE_BUSINESSCASES"
export const UPDATE_BUSINESSCASES = "UPDATE_BUSINESSCASES"
export const ERROR_BUSINESSCASES = "ERROR_BUSINESSCASES"

/* BUSINESSCASES_TYPES */
export const REQUEST_BUSINESSCASES_TYPES = "REQUEST_BUSINESSCASES_TYPES"
export const RECEIVE_BUSINESSCASES_TYPES = "RECEIVE_BUSINESSCASES_TYPES"
export const UPDATE_BUSINESSCASES_TYPES = "UPDATE_BUSINESSCASES_TYPES"
export const ERROR_BUSINESSCASES_TYPES = "ERROR_BUSINESSCASES_TYPES"

/* BUSINESSCASES_COLUMNS */
export const REQUEST_BUSINESSCASES_COLUMNS = "REQUEST_BUSINESSCASES_COLUMNS"
export const RECEIVE_BUSINESSCASES_COLUMNS = "RECEIVE_BUSINESSCASES_COLUMNS"
export const UPDATE_BUSINESSCASES_COLUMNS = "UPDATE_BUSINESSCASES_COLUMNS"
export const ERROR_BUSINESSCASES_COLUMNS = "ERROR_BUSINESSCASES_COLUMNS"

/* BUSINESSCASES_TAGS */
export const REQUEST_BUSINESSCASES_TAGS = "REQUEST_BUSINESSCASES_TAGS"
export const RECEIVE_BUSINESSCASES_TAGS = "RECEIVE_BUSINESSCASES_TAGS"
export const UPDATE_BUSINESSCASES_TAGS = "UPDATE_BUSINESSCASES_TAGS"
export const ERROR_BUSINESSCASES_TAGS = "ERROR_BUSINESSCASES_TAGS"

/* BUSINESSCASES_DASHBOARD */
export const REQUEST_BUSINESSCASES_DASHBOARD = "REQUEST_BUSINESSCASES_DASHBOARD"
export const RECEIVE_BUSINESSCASES_DASHBOARD = "RECEIVE_BUSINESSCASES_DASHBOARD"
export const UPDATE_BUSINESSCASES_DASHBOARD = "UPDATE_BUSINESSCASES_DASHBOARD"
export const ERROR_BUSINESSCASES_DASHBOARD = "ERROR_BUSINESSCASES_DASHBOARD"

/* LIQUIDATIONS_COLUMNS */
export const REQUEST_LIQUIDATIONS_COLUMNS = "REQUEST_LIQUIDATIONS_COLUMNS"
export const RECEIVE_LIQUIDATIONS_COLUMNS = "RECEIVE_LIQUIDATIONS_COLUMNS"
export const UPDATE_LIQUIDATIONS_COLUMNS = "UPDATE_LIQUIDATIONS_COLUMNS"
export const ERROR_LIQUIDATIONS_COLUMNS = "ERROR_LIQUIDATIONS_COLUMNS"
/* CLIENTS_FORMTYPES */
export const REQUEST_CLIENTS_FORMTYPES = "REQUEST_CLIENTS_FORMTYPES"
export const RECEIVE_CLIENTS_FORMTYPES = "RECEIVE_CLIENTS_FORMTYPES"
export const UPDATE_CLIENTS_FORMTYPES = "UPDATE_CLIENTS_FORMTYPES"
export const ERROR_CLIENTS_FORMTYPES = "ERROR_CLIENTS_FORMTYPES"
/* CLIENTS_STATES */
export const REQUEST_CLIENTS_STATES = "REQUEST_CLIENTS_STATES"
export const RECEIVE_CLIENTS_STATES = "RECEIVE_CLIENTS_STATES"
export const UPDATE_CLIENTS_STATES = "UPDATE_CLIENTS_STATES"
export const ERROR_CLIENTS_STATES = "ERROR_CLIENTS_STATES"
/* COMPANIES_VPPS */
export const REQUEST_COMPANIES_VPPS = "REQUEST_COMPANIES_VPPS"
export const RECEIVE_COMPANIES_VPPS = "RECEIVE_COMPANIES_VPPS"
export const UPDATE_COMPANIES_VPPS = "UPDATE_COMPANIES_VPPS"
export const ERROR_COMPANIES_VPPS = "ERROR_COMPANIES_VPPS"
/* USERS_CONTACTS */
export const REQUEST_USERS_CONTACTS = "REQUEST_USERS_CONTACTS"
export const RECEIVE_USERS_CONTACTS = "RECEIVE_USERS_CONTACTS"
export const UPDATE_USERS_CONTACTS = "UPDATE_USERS_CONTACTS"
export const ERROR_USERS_CONTACTS = "ERROR_USERS_CONTACTS"
/* LOGS_CLIENTLOGS */
export const REQUEST_LOGS_CLIENTLOGS = "REQUEST_LOGS_CLIENTLOGS"
export const RECEIVE_LOGS_CLIENTLOGS = "RECEIVE_LOGS_CLIENTLOGS"
export const UPDATE_LOGS_CLIENTLOGS = "UPDATE_LOGS_CLIENTLOGS"
export const ERROR_LOGS_CLIENTLOGS = "ERROR_LOGS_CLIENTLOGS"
/* LOGS_EXPORTLOGS */
export const REQUEST_LOGS_EXPORTLOGS = "REQUEST_LOGS_EXPORTLOGS"
export const RECEIVE_LOGS_EXPORTLOGS = "RECEIVE_LOGS_EXPORTLOGS"
export const UPDATE_LOGS_EXPORTLOGS = "UPDATE_LOGS_EXPORTLOGS"
export const ERROR_LOGS_EXPORTLOGS = "ERROR_LOGS_EXPORTLOGS"
/* COMPANIES_BUSINESSPRODUCTS */
export const REQUEST_COMPANIES_BUSINESSPRODUCTS = "REQUEST_COMPANIES_BUSINESSPRODUCTS"
export const RECEIVE_COMPANIES_BUSINESSPRODUCTS = "RECEIVE_COMPANIES_BUSINESSPRODUCTS"
export const UPDATE_COMPANIES_BUSINESSPRODUCTS = "UPDATE_COMPANIES_BUSINESSPRODUCTS"
export const ERROR_COMPANIES_BUSINESSPRODUCTS = "ERROR_COMPANIES_BUSINESSPRODUCTS"
/* SETTINGS_CRMMODULES */
export const REQUEST_SETTINGS_CRMMODULES = "REQUEST_SETTINGS_CRMMODULES"
export const RECEIVE_SETTINGS_CRMMODULES = "RECEIVE_SETTINGS_CRMMODULES"
export const UPDATE_SETTINGS_CRMMODULES = "UPDATE_SETTINGS_CRMMODULES"
export const ERROR_SETTINGS_CRMMODULES = "ERROR_SETTINGS_CRMMODULES"
/* SETTINGS_CRMCLIENTMODULES */
export const REQUEST_SETTINGS_CRMCLIENTMODULES = "REQUEST_SETTINGS_CRMCLIENTMODULES"
export const RECEIVE_SETTINGS_CRMCLIENTMODULES = "RECEIVE_SETTINGS_CRMCLIENTMODULES"
export const UPDATE_SETTINGS_CRMCLIENTMODULES = "UPDATE_SETTINGS_CRMCLIENTMODULES"
export const ERROR_SETTINGS_CRMCLIENTMODULES = "ERROR_SETTINGS_CRMCLIENTMODULES"
/* COMPANIES_GLOBALBUSINESSPRODUCTS */
export const REQUEST_COMPANIES_GLOBALBUSINESSPRODUCTS = "REQUEST_COMPANIES_GLOBALBUSINESSPRODUCTS"
export const RECEIVE_COMPANIES_GLOBALBUSINESSPRODUCTS = "RECEIVE_COMPANIES_GLOBALBUSINESSPRODUCTS"
export const UPDATE_COMPANIES_GLOBALBUSINESSPRODUCTS = "UPDATE_COMPANIES_GLOBALBUSINESSPRODUCTS"
export const ERROR_COMPANIES_GLOBALBUSINESSPRODUCTS = "ERROR_COMPANIES_GLOBALBUSINESSPRODUCTS"
/* EXTRANETS_DICONTRACTS */
export const REQUEST_EXTRANETS_DICONTRACTS = "REQUEST_EXTRANETS_DICONTRACTS"
export const RECEIVE_EXTRANETS_DICONTRACTS = "RECEIVE_EXTRANETS_DICONTRACTS"
export const UPDATE_EXTRANETS_DICONTRACTS = "UPDATE_EXTRANETS_DICONTRACTS"
export const ERROR_EXTRANETS_DICONTRACTS = "ERROR_EXTRANETS_DICONTRACTS"
/* EXTRANETS_DISTATES */
export const REQUEST_EXTRANETS_DISTATES = "REQUEST_EXTRANETS_DISTATES"
export const RECEIVE_EXTRANETS_DISTATES = "RECEIVE_EXTRANETS_DISTATES"
export const UPDATE_EXTRANETS_DISTATES = "UPDATE_EXTRANETS_DISTATES"
export const ERROR_EXTRANETS_DISTATES = "ERROR_EXTRANETS_DISTATES"
/* EXTRANETS_KOCONTRACTS */
export const REQUEST_EXTRANETS_KOCONTRACTS = "REQUEST_EXTRANETS_KOCONTRACTS"
export const RECEIVE_EXTRANETS_KOCONTRACTS = "RECEIVE_EXTRANETS_KOCONTRACTS"
export const UPDATE_EXTRANETS_KOCONTRACTS = "UPDATE_EXTRANETS_KOCONTRACTS"
export const ERROR_EXTRANETS_KOCONTRACTS = "ERROR_EXTRANETS_KOCONTRACTS"
/* EXTRANETS_KOSTATES */
export const REQUEST_EXTRANETS_KOSTATES = "REQUEST_EXTRANETS_KOSTATES"
export const RECEIVE_EXTRANETS_KOSTATES = "RECEIVE_EXTRANETS_KOSTATES"
export const UPDATE_EXTRANETS_KOSTATES = "UPDATE_EXTRANETS_KOSTATES"
export const ERROR_EXTRANETS_KOSTATES = "ERROR_EXTRANETS_KOSTATES"
/* EXTRANETS_CPCONTRACTS */
export const REQUEST_EXTRANETS_CPCONTRACTS = "REQUEST_EXTRANETS_CPCONTRACTS"
export const RECEIVE_EXTRANETS_CPCONTRACTS = "RECEIVE_EXTRANETS_CPCONTRACTS"
export const UPDATE_EXTRANETS_CPCONTRACTS = "UPDATE_EXTRANETS_CPCONTRACTS"
export const ERROR_EXTRANETS_CPCONTRACTS = "ERROR_EXTRANETS_CPCONTRACTS"
/* EXTRANETS_CPSTATES */
export const REQUEST_EXTRANETS_CPSTATES = "REQUEST_EXTRANETS_CPSTATES"
export const RECEIVE_EXTRANETS_CPSTATES = "RECEIVE_EXTRANETS_CPSTATES"
export const UPDATE_EXTRANETS_CPSTATES = "UPDATE_EXTRANETS_CPSTATES"
export const ERROR_EXTRANETS_CPSTATES = "ERROR_EXTRANETS_CPSTATES"
/* EXTRANETS_UNCONTRACTS */
export const REQUEST_EXTRANETS_UNCONTRACTS = "REQUEST_EXTRANETS_UNCONTRACTS"
export const RECEIVE_EXTRANETS_UNCONTRACTS = "RECEIVE_EXTRANETS_UNCONTRACTS"
export const UPDATE_EXTRANETS_UNCONTRACTS = "UPDATE_EXTRANETS_UNCONTRACTS"
export const ERROR_EXTRANETS_UNCONTRACTS = "ERROR_EXTRANETS_UNCONTRACTS"
/* EXTRANETS_UNSTATES */
export const REQUEST_EXTRANETS_UNSTATES = "REQUEST_EXTRANETS_UNSTATES"
export const RECEIVE_EXTRANETS_UNSTATES = "RECEIVE_EXTRANETS_UNSTATES"
export const UPDATE_EXTRANETS_UNSTATES = "UPDATE_EXTRANETS_UNSTATES"
export const ERROR_EXTRANETS_UNSTATES = "ERROR_EXTRANETS_UNSTATES"
/* EXTRANETS_PLCONTRACTS */
export const REQUEST_EXTRANETS_PLCONTRACTS = "REQUEST_EXTRANETS_PLCONTRACTS"
export const RECEIVE_EXTRANETS_PLCONTRACTS = "RECEIVE_EXTRANETS_PLCONTRACTS"
export const UPDATE_EXTRANETS_PLCONTRACTS = "UPDATE_EXTRANETS_PLCONTRACTS"
export const ERROR_EXTRANETS_PLCONTRACTS = "ERROR_EXTRANETS_PLCONTRACTS"
/* EXTRANETS_PLSTATES */
export const REQUEST_EXTRANETS_PLSTATES = "REQUEST_EXTRANETS_PLSTATES"
export const RECEIVE_EXTRANETS_PLSTATES = "RECEIVE_EXTRANETS_PLSTATES"
export const UPDATE_EXTRANETS_PLSTATES = "UPDATE_EXTRANETS_PLSTATES"
export const ERROR_EXTRANETS_PLSTATES = "ERROR_EXTRANETS_PLSTATES"
/* EXTRANETS_SLCONTRACTS */
export const REQUEST_EXTRANETS_SLCONTRACTS = "REQUEST_EXTRANETS_SLCONTRACTS"
export const RECEIVE_EXTRANETS_SLCONTRACTS = "RECEIVE_EXTRANETS_SLCONTRACTS"
export const UPDATE_EXTRANETS_SLCONTRACTS = "UPDATE_EXTRANETS_SLCONTRACTS"
export const ERROR_EXTRANETS_SLCONTRACTS = "ERROR_EXTRANETS_SLCONTRACTS"
/* EXTRANETS_SLSTATES */
export const REQUEST_EXTRANETS_SLSTATES = "REQUEST_EXTRANETS_SLSTATES"
export const RECEIVE_EXTRANETS_SLSTATES = "RECEIVE_EXTRANETS_SLSTATES"
export const UPDATE_EXTRANETS_SLSTATES = "UPDATE_EXTRANETS_SLSTATES"
export const ERROR_EXTRANETS_SLSTATES = "ERROR_EXTRANETS_SLSTATES"
/* EXTRANETS_CSCONTRACTS */
export const REQUEST_EXTRANETS_CSCONTRACTS = "REQUEST_EXTRANETS_CSCONTRACTS"
export const RECEIVE_EXTRANETS_CSCONTRACTS = "RECEIVE_EXTRANETS_CSCONTRACTS"
export const UPDATE_EXTRANETS_CSCONTRACTS = "UPDATE_EXTRANETS_CSCONTRACTS"
export const ERROR_EXTRANETS_CSCONTRACTS = "ERROR_EXTRANETS_CSCONTRACTS"
/* EXTRANETS_CSSTATES */
export const REQUEST_EXTRANETS_CSSTATES = "REQUEST_EXTRANETS_CSSTATES"
export const RECEIVE_EXTRANETS_CSSTATES = "RECEIVE_EXTRANETS_CSSTATES"
export const UPDATE_EXTRANETS_CSSTATES = "UPDATE_EXTRANETS_CSSTATES"
export const ERROR_EXTRANETS_CSSTATES = "ERROR_EXTRANETS_CSSTATES"
/* EXTRANETS_MACONTRACTS */
export const REQUEST_EXTRANETS_MACONTRACTS = "REQUEST_EXTRANETS_MACONTRACTS"
export const RECEIVE_EXTRANETS_MACONTRACTS = "RECEIVE_EXTRANETS_MACONTRACTS"
export const UPDATE_EXTRANETS_MACONTRACTS = "UPDATE_EXTRANETS_MACONTRACTS"
export const ERROR_EXTRANETS_MACONTRACTS = "ERROR_EXTRANETS_MACONTRACTS"
/* EXTRANETS_MASTATES */
export const REQUEST_EXTRANETS_MASTATES = "REQUEST_EXTRANETS_MASTATES"
export const RECEIVE_EXTRANETS_MASTATES = "RECEIVE_EXTRANETS_MASTATES"
export const UPDATE_EXTRANETS_MASTATES = "UPDATE_EXTRANETS_MASTATES"
export const ERROR_EXTRANETS_MASTATES = "ERROR_EXTRANETS_MASTATES"
/*extranets_here*/
/* BILLING_PREMIUMBILLINGS */
export const REQUEST_BILLING_PREMIUMBILLINGS = "REQUEST_BILLING_PREMIUMBILLINGS"
export const RECEIVE_BILLING_PREMIUMBILLINGS = "RECEIVE_BILLING_PREMIUMBILLINGS"
export const UPDATE_BILLING_PREMIUMBILLINGS = "UPDATE_BILLING_PREMIUMBILLINGS"
export const ERROR_BILLING_PREMIUMBILLINGS = "ERROR_BILLING_PREMIUMBILLINGS"
/* SETTINGS_CREDENTIALS */
export const REQUEST_SETTINGS_CREDENTIALS = "REQUEST_SETTINGS_CREDENTIALS"
export const RECEIVE_SETTINGS_CREDENTIALS = "RECEIVE_SETTINGS_CREDENTIALS"
export const UPDATE_SETTINGS_CREDENTIALS = "UPDATE_SETTINGS_CREDENTIALS"
export const ERROR_SETTINGS_CREDENTIALS = "ERROR_SETTINGS_CREDENTIALS"
/* CONTRACTS_STATES */
export const REQUEST_CONTRACTS_STATES = "REQUEST_CONTRACTS_STATES"
export const RECEIVE_CONTRACTS_STATES = "RECEIVE_CONTRACTS_STATES"
export const UPDATE_CONTRACTS_STATES = "UPDATE_CONTRACTS_STATES"
export const ERROR_CONTRACTS_STATES = "ERROR_CONTRACTS_STATES"
/* BANKS_ACCOUNTS */
export const REQUEST_BANKS_ACCOUNTS = "REQUEST_BANKS_ACCOUNTS"
export const RECEIVE_BANKS_ACCOUNTS = "RECEIVE_BANKS_ACCOUNTS"
export const UPDATE_BANKS_ACCOUNTS = "UPDATE_BANKS_ACCOUNTS"
export const ERROR_BANKS_ACCOUNTS = "ERROR_BANKS_ACCOUNTS"
/* BANKS_TRANSACTIONS */
export const REQUEST_BANKS_TRANSACTIONS = "REQUEST_BANKS_TRANSACTIONS"
export const RECEIVE_BANKS_TRANSACTIONS = "RECEIVE_BANKS_TRANSACTIONS"
export const UPDATE_BANKS_TRANSACTIONS = "UPDATE_BANKS_TRANSACTIONS"
export const ERROR_BANKS_TRANSACTIONS = "ERROR_BANKS_TRANSACTIONS"
/* CRECORDS_EMPLOYEES */
export const REQUEST_CRECORDS_EMPLOYEES = "REQUEST_CRECORDS_EMPLOYEES"
export const RECEIVE_CRECORDS_EMPLOYEES = "RECEIVE_CRECORDS_EMPLOYEES"
export const UPDATE_CRECORDS_EMPLOYEES = "UPDATE_CRECORDS_EMPLOYEES"
export const ERROR_CRECORDS_EMPLOYEES = "ERROR_CRECORDS_EMPLOYEES"
/* CRECORDS_PROJECTS */
export const REQUEST_CRECORDS_PROJECTS = "REQUEST_CRECORDS_PROJECTS"
export const RECEIVE_CRECORDS_PROJECTS = "RECEIVE_CRECORDS_PROJECTS"
export const UPDATE_CRECORDS_PROJECTS = "UPDATE_CRECORDS_PROJECTS"
export const ERROR_CRECORDS_PROJECTS = "ERROR_CRECORDS_PROJECTS"
/* CRECORDS_DAYWORKS */
export const REQUEST_CRECORDS_DAYWORKS = "REQUEST_CRECORDS_DAYWORKS"
export const RECEIVE_CRECORDS_DAYWORKS = "RECEIVE_CRECORDS_DAYWORKS"
export const UPDATE_CRECORDS_DAYWORKS = "UPDATE_CRECORDS_DAYWORKS"
export const ERROR_CRECORDS_DAYWORKS = "ERROR_CRECORDS_DAYWORKS"
/* CRECORDS_ESTATES */
export const REQUEST_CRECORDS_ESTATES = "REQUEST_CRECORDS_ESTATES"
export const RECEIVE_CRECORDS_ESTATES = "RECEIVE_CRECORDS_ESTATES"
export const UPDATE_CRECORDS_ESTATES = "UPDATE_CRECORDS_ESTATES"
export const ERROR_CRECORDS_ESTATES = "ERROR_CRECORDS_ESTATES"
/* USERS_ALLNOTIFICATIONS */
export const REQUEST_USERS_ALLNOTIFICATIONS = "REQUEST_USERS_ALLNOTIFICATIONS"
export const RECEIVE_USERS_ALLNOTIFICATIONS = "RECEIVE_USERS_ALLNOTIFICATIONS"
export const UPDATE_USERS_ALLNOTIFICATIONS = "UPDATE_USERS_ALLNOTIFICATIONS"
export const ERROR_USERS_ALLNOTIFICATIONS = "ERROR_USERS_ALLNOTIFICATIONS"
/* BILLING_TARIFFS */
export const REQUEST_BILLING_TARIFFS = "REQUEST_BILLING_TARIFFS"
export const RECEIVE_BILLING_TARIFFS = "RECEIVE_BILLING_TARIFFS"
export const UPDATE_BILLING_TARIFFS = "UPDATE_BILLING_TARIFFS"
export const ERROR_BILLING_TARIFFS = "ERROR_BILLING_TARIFFS"
/* BILLING_TARIFFENTRIES */
export const REQUEST_BILLING_TARIFFENTRIES = "REQUEST_BILLING_TARIFFENTRIES"
export const RECEIVE_BILLING_TARIFFENTRIES = "RECEIVE_BILLING_TARIFFENTRIES"
export const UPDATE_BILLING_TARIFFENTRIES = "UPDATE_BILLING_TARIFFENTRIES"
export const ERROR_BILLING_TARIFFENTRIES = "ERROR_BILLING_TARIFFENTRIES"
/* LIQUIDATIONS_STATS */
export const REQUEST_LIQUIDATIONS_STATS = "REQUEST_LIQUIDATIONS_STATS"
export const RECEIVE_LIQUIDATIONS_STATS = "RECEIVE_LIQUIDATIONS_STATS"
export const ERROR_LIQUIDATIONS_STATS = "ERROR_LIQUIDATIONS_STATS"
/* LIQUIDATIONS_LONGSTANDINGS */
export const REQUEST_LIQUIDATIONS_LONGSTANDINGS = "REQUEST_LIQUIDATIONS_LONGSTANDINGS"
export const RECEIVE_LIQUIDATIONS_LONGSTANDINGS = "RECEIVE_LIQUIDATIONS_LONGSTANDINGS"
export const UPDATE_LIQUIDATIONS_LONGSTANDINGS = "UPDATE_LIQUIDATIONS_LONGSTANDINGS"
export const ERROR_LIQUIDATIONS_LONGSTANDINGS = "ERROR_LIQUIDATIONS_LONGSTANDINGS"
/* SETTINGS_TAGCATEGORIES */
export const REQUEST_SETTINGS_TAGCATEGORIES = "REQUEST_SETTINGS_TAGCATEGORIES"
export const RECEIVE_SETTINGS_TAGCATEGORIES = "RECEIVE_SETTINGS_TAGCATEGORIES"
export const UPDATE_SETTINGS_TAGCATEGORIES = "UPDATE_SETTINGS_TAGCATEGORIES"
export const ERROR_SETTINGS_TAGCATEGORIES = "ERROR_SETTINGS_TAGCATEGORIES"
/* SETTINGS_TAGS */
export const REQUEST_SETTINGS_TAGS = "REQUEST_SETTINGS_TAGS"
export const RECEIVE_SETTINGS_TAGS = "RECEIVE_SETTINGS_TAGS"
export const UPDATE_SETTINGS_TAGS = "UPDATE_SETTINGS_TAGS"
export const ERROR_SETTINGS_TAGS = "ERROR_SETTINGS_TAGS"
/* MARKETINGS */
export const REQUEST_MARKETINGS = "REQUEST_MARKETINGS"
export const RECEIVE_MARKETINGS = "RECEIVE_MARKETINGS"
export const UPDATE_MARKETINGS = "UPDATE_MARKETINGS"
export const ERROR_MARKETINGS = "ERROR_MARKETINGS"
/* ACTIVITIES_PROVIDERS */
export const REQUEST_ACTIVITIES_PROVIDERS = "REQUEST_ACTIVITIES_PROVIDERS"
export const RECEIVE_ACTIVITIES_PROVIDERS = "RECEIVE_ACTIVITIES_PROVIDERS"
export const UPDATE_ACTIVITIES_PROVIDERS = "UPDATE_ACTIVITIES_PROVIDERS"
export const ERROR_ACTIVITIES_PROVIDERS = "ERROR_ACTIVITIES_PROVIDERS"
/* ACTIVITIES_TYPES */
export const REQUEST_ACTIVITIES_TYPES = "REQUEST_ACTIVITIES_TYPES"
export const RECEIVE_ACTIVITIES_TYPES = "RECEIVE_ACTIVITIES_TYPES"
export const UPDATE_ACTIVITIES_TYPES = "UPDATE_ACTIVITIES_TYPES"
export const ERROR_ACTIVITIES_TYPES = "ERROR_ACTIVITIES_TYPES"
/* LIQUIDATIONS_TODOS */
export const REQUEST_LIQUIDATIONS_TODOS = "REQUEST_LIQUIDATIONS_TODOS"
export const RECEIVE_LIQUIDATIONS_TODOS = "RECEIVE_LIQUIDATIONS_TODOS"
export const UPDATE_LIQUIDATIONS_TODOS = "UPDATE_LIQUIDATIONS_TODOS"
export const ERROR_LIQUIDATIONS_TODOS = "ERROR_LIQUIDATIONS_TODOS"
/* BILLING_PAYMENTS */
export const REQUEST_BILLING_PAYMENTS = "REQUEST_BILLING_PAYMENTS"
export const RECEIVE_BILLING_PAYMENTS = "RECEIVE_BILLING_PAYMENTS"
export const UPDATE_BILLING_PAYMENTS = "UPDATE_BILLING_PAYMENTS"
export const ERROR_BILLING_PAYMENTS = "ERROR_BILLING_PAYMENTS"
/* CALENDAR EVENTS */
export const REQUEST_CALENDAR_EVENTS = "REQUEST_CALENDAR_EVENTS"
export const RECEIVE_CALENDAR_EVENTS = "RECEIVE_CALENDAR_EVENTS"
export const UPDATE_CALENDAR_EVENTS = "UPDATE_CALENDAR_EVENTS"
export const ERROR_CALENDAR_EVENTS = "ERROR_CALENDAR_EVENTS"
/* CLIENTS_SIGNTYPES */
export const REQUEST_CLIENTS_SIGNTYPES = "REQUEST_CLIENTS_SIGNTYPES"
export const RECEIVE_CLIENTS_SIGNTYPES = "RECEIVE_CLIENTS_SIGNTYPES"
export const UPDATE_CLIENTS_SIGNTYPES = "UPDATE_CLIENTS_SIGNTYPES"
export const ERROR_CLIENTS_SIGNTYPES = "ERROR_CLIENTS_SIGNTYPES"
/*modules_here*/